import { Component, OnInit } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';
import { ToastController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';

@Component({
    selector: 'app-account-number',
    templateUrl: './account-number.component.html',
    styleUrls: ['./account-number.component.scss'],
    standalone: false
})
export class AccountNumberComponent  implements OnInit {

  public accountNumber!: string | undefined;
  public busy: boolean = true;

  constructor(
    public contractService: ContractService, 
    private toastController: ToastController, 
    private translocoService: TranslocoService
  ) {}

  ngOnInit() {
    this.contractService.getAccountNumber()
    .subscribe((accountNumber) => {
      this.accountNumber = accountNumber;
      this.busy = false;
    })
  }

  async copyToClipboard() {
    await Clipboard.write({
      string: this.accountNumber,
    });
    this.showToast(this.translocoService.translate('TEXT_COPIED'));
  }
  
  async showToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000,
      position: 'bottom',
    });
    toast.present();
  }
}




